@if (regulationInfo$ | async; as info) {
  <mat-card appearance="outlined" class="status-banner">
    <mat-card-content>
      <sms-progress-tracker [stages]="stages$ | async"></sms-progress-tracker>

      @switch (info.status) {
        @case (RegulationStatus.REGULATION_STATUS_APPROVED) {
          <p class="status-message">{{ approvedStatusMessage$ | async }}</p>
          @if (provisioningFailureReason$ | async; as failureReason) {
            <glxy-alert type="error" class="rejection-alert">
              <strong>{{ 'SMS_REGULATION.COMMON.STATUS.STAGES.PHONE_NUMBER_PROVISIONING' | translate }}</strong>
              <p>{{ failureReason }}</p>
            </glxy-alert>
          }
        }
        @case (RegulationStatus.REGULATION_STATUS_REJECTED) {
          <glxy-alert type="error" class="rejection-alert">
            @if (info.rejectionDetails?.length || info.rejectionReason) {
              <strong>{{ 'SMS_REGULATION.COMMON.STATUS.REJECTION_SUMMARY' | translate }}</strong>
            } @else {
              <strong>{{ 'SMS_REGULATION.COMMON.STATUS.REJECTED_NO_REASON_TITLE' | translate }}</strong>
              {{ 'SMS_REGULATION.COMMON.STATUS.REJECTED_NO_REASON_DETAIL' | translate }}
            }
            <br />
            {{ 'SMS_REGULATION.COMMON.STATUS.REJECTED_UPDATE_HINT' | translate }}
          </glxy-alert>

          @if (info.rejectionDetails?.length) {
            <div class="rejection-details-list">
              @for (detail of info.rejectionDetails; track $index) {
                <glxy-alert type="error">
                  <strong>{{ resourceTypeLabel(detail.resourceType) }}</strong>
                  <p>{{ rejectionMessage(detail.errorCodes, detail.failureReason) }}</p>
                </glxy-alert>
              }
            </div>
          } @else if (info.rejectionReason) {
            <p class="rejection-reason-fallback">{{ info.rejectionReason }}</p>
          }
        }
        @default {
          <p class="status-message">
            {{ 'SMS_REGULATION.COMMON.STATUS.PENDING_REVIEW_MESSAGE' | translate }}
          </p>
        }
      }
    </mat-card-content>
  </mat-card>
}
